export default class RequestSupportCreation {
  public message: string;

  constructor(message: string) {
    this.message = message;
  }
}
